import { Helmet } from "react-helmet";

const BrowserHeader = ({title} : {title: string}) => {
  return (
    <Helmet>
    <title>{title}</title>
  </Helmet>
  )
}

export default BrowserHeader